import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { replace } from 'redux-router';
import {
  checkDuplicateAndQuarantineDeferred,
  exceptionTypes,
  fetchUserInfoDeferred,
  logException,
  LogException,
  productInfoDeferred
} from '../actions/Actions';
import { IProductInfo, IUserInfo, Replace } from '../CustomTypes';
import {
  getRedirectUrlInLocalStorage,
  setRedirectUrlInLocalStorage
} from '../fastflowUtils';
import { sccPulseTrackPageView } from '../PulseUtils';

/**
 * Page used when we want to skip first product view. Empty page which redirects to next page in flow based
 * on userinfo/product.
 */
export interface IDispatchProps {
  logException: LogException;
  replace: Replace;
}

export interface IStateProps {
  paymentMethodId?: string;
  purchasedSubscriptionId?: number;
  redirectUri?: string;
  referer?: string;
  source?: string;
  medium?: string;
  content?: string;
  campaign?: string;
  term?: string;
  sig?: string;
  spidId: string;
  __rct?: string;
}

export interface IProps extends IDispatchProps, IStateProps {}

export class StartPage extends React.Component<IProps, {}> {
  constructor() {
    super();
    this.goToNextPage = this.goToNextPage.bind(this);
  }

  public componentDidMount() {
    // Set the redirect params in localStorage for later use
    setRedirectUrlInLocalStorage({
      __rct: this.props.__rct,
      redirectUri: this.props.redirectUri,
      referer: this.props.referer,
      utmCampaign: this.props.campaign,
      utmContent: this.props.content,
      utmMedium: this.props.medium,
      utmSource: this.props.source,
      utmTerm: this.props.term
    });

    const {
      logException,
      purchasedSubscriptionId,
      paymentMethodId,
      sig,
      spidId
    } = this.props;
    let redirectParams = `?${getRedirectUrlInLocalStorage()}`;
    if (purchasedSubscriptionId) {
      redirectParams = `${redirectParams}&purchasedSubscriptionId=${purchasedSubscriptionId}`;
    }
    if (paymentMethodId) {
      redirectParams = `${redirectParams}&paymentMethodId=${paymentMethodId}&spidId=${spidId}&sig=${sig}`;
    }
    productInfoDeferred.promise.then(product => {
      fetchUserInfoDeferred.promise
        .then(user => {
          checkDuplicateAndQuarantineDeferred.promise
            .then(duplicateRes => {
              if (
                duplicateRes.isDuplicate === true ||
                duplicateRes.isQuarantine === true
              ) {
                // Do nothing. We are sent to duplicate/quarantine page
              } else {
                this.goToNextPage(product, user, redirectParams);
              }
            })
            .catch(e => {
              this.goToNextPage(product, user, redirectParams);
              logException(exceptionTypes.EXCEPTION, e);
            });
        })
        .catch(e => {
          sccPulseTrackPageView(product, {}, 'Viewed order form start');
          this.props.replace(
            `/products/${product.productId}/usersearch${redirectParams}`
          );
          logException(exceptionTypes.EXCEPTION, e);
        });
    });
  }

  public render() {
    return <div />;
  }

  private goToNextPage(
    product: IProductInfo,
    user: IUserInfo,
    redirectParams: string
  ) {
    const { productId, pureDigital } = product;
    sccPulseTrackPageView(product, user, 'Viewed order form start');
    if (pureDigital) {
      this.props.replace(
        `/products/${productId}/selectpaymentmethod${redirectParams}`
      );
    } else if (user.zipCode && user.city) {
      this.props.replace(`/products/${productId}/userinfo${redirectParams}`);
    } else {
      this.props.replace(`/products/${productId}/address${redirectParams}`);
    }
  }
}

export default connect<IStateProps, IDispatchProps, {}>(
  state =>
    ({
      __rct: state.router.location.query.__rct,
      campaign: state.router.location.query.utm_campaign,
      content: state.router.location.query.utm_content,
      medium: state.router.location.query.utm_medium,
      paymentMethodId: state.router.location.query.paymentMethodId,
      purchasedSubscriptionId:
        state.router.location.query.purchasedSubscriptionId,
      redirectUri: state.router.location.query.redirect_uri,
      referer: state.router.location.query.referer,
      sig: state.router.location.query.sig,
      source: state.router.location.query.utm_source,
      spidId: state.router.location.query.spidId,
      term: state.router.location.query.utm_term
    } as IStateProps),
  dispatch =>
    bindActionCreators({ logException, replace }, dispatch) as IDispatchProps
)(StartPage);



// WEBPACK FOOTER //
// ./src/page-components/Start.tsx